import {MAILING} from '../../actions/mailing/mailingActionTypes';

const INITIAL_STATE = {
  loading: true,
  mailing: [],
  editData: {},
  isView: false
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case MAILING.GET_MAILINGS:
      return {...state, loading: true, mailing: []};
    case MAILING.GET_MAILINGS_SUCCESS:
      return {...state, mailing: action.payload.data.data, loading: false};
    case MAILING.GET_MAILINGS_FAIL:
      return {...state, mailing: [], loading: false};
    case MAILING.SET_MAILING_POPUP_DATA:
      return {...state, editData: action.payload.data, isView: action.payload.isView ?? state.isView};
    default:
      return state;
  }
}
